export default __webpack_public_path__ + "6d9486b33dbec7593b2b5f20bbf87057.svg";